import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getEnvVariables} from "helpers/getEnvVariables";

const {REACT_APP_URL} = getEnvVariables();

// The customer is never sent: the server takes it from the token.
export const followApi = createApi({
  reducerPath: "follow",
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_URL,
    prepareHeaders: (headers) => {
      const token = JSON.parse(localStorage.getItem("user")!)?.token;
      if (token) headers.set("Authorization", token);
      return headers;
    },
  }),
  tagTypes: ["Follow"],
  endpoints: (builder) => ({
    // With target, total > 0 means the customer follows that organizer.
    getFollows: builder.query({
      query: ({
        target,
        page = 1,
        limit = 20,
      }: {
        target?: string;
        page?: number;
        limit?: number;
      }) => ({
        url: "api/v2/follow",
        params: {targetType: "Organizer", page, limit, ...(target && {target})},
      }),
      providesTags: ["Follow"],
    }),
    getFollowersCount: builder.query({
      query: (organizerId: string) =>
        `api/v2/follow/Organizer/${organizerId}/count`,
      providesTags: ["Follow"],
    }),
    // 201 starts following, 200 when it already did.
    followOrganizer: builder.mutation({
      query: (organizerId: string) => ({
        url: `api/v2/follow/Organizer/${organizerId}`,
        method: "POST",
      }),
      invalidatesTags: ["Follow"],
    }),
    // 200 even when it wasn't following.
    unfollowOrganizer: builder.mutation({
      query: (organizerId: string) => ({
        url: `api/v2/follow/Organizer/${organizerId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Follow"],
    }),
    updateFollowNotify: builder.mutation({
      query: ({
        organizerId,
        notify,
      }: {
        organizerId: string;
        notify: boolean;
      }) => ({
        url: `api/v2/follow/Organizer/${organizerId}`,
        method: "PUT",
        body: {notify},
      }),
      invalidatesTags: ["Follow"],
    }),
  }),
});

export const {
  useGetFollowsQuery,
  useGetFollowersCountQuery,
  useFollowOrganizerMutation,
  useUnfollowOrganizerMutation,
  useUpdateFollowNotifyMutation,
} = followApi;
